import { render, staticRenderFns } from "./CellarDetail.vue?vue&type=template&id=6c360935&scoped=true&"
import script from "./CellarDetail.vue?vue&type=script&lang=ts&"
export * from "./CellarDetail.vue?vue&type=script&lang=ts&"
import style0 from "./CellarDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CellarDetail.vue?vue&type=style&index=1&id=6c360935&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c360935",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAvatar,VBtn,VDivider,VFlex,VLayout,VProgressCircular})
